import { render } from "./TheLogin.vue?vue&type=template&id=a52c08e4&scoped=true"
import script from "./TheLogin.vue?vue&type=script&lang=js"
export * from "./TheLogin.vue?vue&type=script&lang=js"

import "./TheLogin.vue?vue&type=style&index=0&id=a52c08e4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a52c08e4"

export default script